import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c4240aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "body"
}
const _hoisted_2 = {
  key: 0,
  class: "picture"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "topbgtext" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jiange" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "项目名称：")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "建设单位：")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "代建单位：")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "勘察单位：")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "设计单位：")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "监理单位：")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "施工总承包：")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "专业分包：")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "建筑类型：")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "建筑面积：")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "合同金额：")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "状态：")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "省：")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "市：")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "区/县：")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.reqdata.project)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.reqdata.project.showFileUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _ctx.reqdata.project.showFileUrl
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.reqdata.project.detail ? _ctx.reqdata.project.detail : ""), 1),
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _hoisted_6,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.name), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_7,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.constructionUnitName), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_8,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.daijianUnitName), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_9,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.kanchaUnitName), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_10,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.designUnitName), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_11,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.supervisorUnitName), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_12,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.generalUnitName), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_13,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.zhuanyeUnitName), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_14,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.buildingType), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_15,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.area), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_16,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.amount), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_17,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.status == 1 ? "在建" : "竣工"), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_18,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.province), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_19,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.city), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_20,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.reqdata.project.qu), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}